/**
 * Template: Cart
 * ------------------------------------------------------------------------------
 * Loosely coupled cart page scripts.
 *
 * @namespace cart
 */
import cssClasses from '~/helpers/cssClasses';
import CartTable from '~/components/cart-table';
import '~/sections/recommended-prods';
import CartGiftMessaging from '~/components/cart-gift-messaging';
/**
 * DOM selectors.
 */

const selectors = {
  container: '[js-cart="container"]',
  table: '[js-cart-table="container"]',
  panel: '[js-cart="panel"]'
};
/**
 * DOM node selectors.
 */

const nodeSelectors = {
  container: document.querySelector(selectors.container),
  panel: document.querySelector(selectors.panel)
};
document.addEventListener('DOMContentLoaded', () => {
  if (!nodeSelectors.panel) {
    return;
  }
  /**
   * Render cart table.
   */


  CartTable(selectors.table).init();
  CartGiftMessaging().init();
  /**
   * Set EventBus event listeners.
   */

  Frame.EventBus.listen('AjaxCart:cartEmpty', () => {
    const strings = {
      title: theme.strings.cart.general.title,
      empty: theme.strings.cart.general.empty,
      continueBrowsing: theme.strings.cart.general.continue_browsing
    };
    nodeSelectors.container.innerHTML = "\n      <div class=\"container\">\n        <div class=\"row\">\n          <div class=\"col xs12 m6 offset-m3 text-center\">\n            <h1 class=\"template-cart__empty-title\">".concat(strings.title, "</h1>\n\n            <p class=\"template-cart__empty-text\">\n              ").concat(strings.empty, "\n            </p>\n\n            <a\n              class=\"\n                template-cart__empty-button\n                button\n                button--primary\n                button--large\n              \"\n              href=\"/collections/all-plants\"\n            >\n              ").concat(strings.continueBrowsing, "\n            </a>\n          </div>\n        </div>\n      </div>\n    ");
  });
  Frame.EventBus.listen('CartTable:updating', () => {
    nodeSelectors.panel.classList.add(cssClasses.loading);
  });
  Frame.EventBus.listen('CartTable:rendered', () => {
    nodeSelectors.panel.classList.remove(cssClasses.loading);
  });
});